import NeuroUIMessages from '../../neuro-ui/i18n/index.mjs';
import GuideFrameworkMessages from '../guide-framework/i18n/index.mjs';
export {default as ContactMessages} from './MessageDefinitions.mjs';

export default {
  en: {
    ...NeuroUIMessages.en,
    ...GuideFrameworkMessages.en
  },
};
